<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2>Items</h2>
    </div>
    <div class="mb-4">
      <router-link to="/add-item" class="btn btn-primary">Add New Item</router-link>
    </div>

    <!-- Loading Image -->
    <div v-if="loading" class="d-flex justify-content-center my-4">
      <img src="@/assets/loading.gif" alt="Loading..." class="loading-image" />
    </div>

    <!-- Grid container to display the items -->
    <div v-if="items.length && !loading" class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
      <div class="col" v-for="item in items" :key="item.id">
        <div class="card h-100">
          <!-- Item image -->
          <img
            :src="item.image"
            alt="item image"
            class="item-image img-thumbnail mb-3 w-50"
          />

          <!-- Item details -->
          <div class="card-body">
            <h5 class="card-title">{{ item.displayName || "N/A" }}</h5>
            <p class="card-text"><strong>Number:</strong> {{ item.number }}</p>
            <p class="card-text"><strong>Type:</strong> {{ item.type }}</p>
            <p class="card-text"><strong>Category Code:</strong> {{ item.itemCategoryCode }}</p>
            <p class="card-text"><strong>Inventory:</strong> {{ item.inventory }}</p>
            <p class="card-text"><strong>Unit Price:</strong> ${{ item.unitPrice }}</p>
            <p class="card-text"><strong>Unit Cost:</strong> ${{ item.unitCost }}</p>
            <p class="card-text">
              <strong>Base Unit of Measure:</strong> {{ item.baseUnitOfMeasureCode }}
            </p>
            <p class="card-text"><strong>Blocked:</strong> {{ item.blocked ? "Yes" : "No" }}</p>
            <p class="card-text">
              <strong>Last Modified:</strong> {{ new Date(item.lastModifiedDateTime).toLocaleString() }}
            </p>
            <p class="card-text"><strong>Item ID:</strong> {{ item.id }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { logout } from "@/helper/utils1"; // Use `@` for the src directory
import { getItems } from "@/helper/RestCalls";
export default {
  data() {
    return {
      items: [],
      loading: true,
   };
  },
  async mounted() {
    this.loadItems();
  },
  methods: {
    async loadItems() {
      console.log("calling bc365");
      try {
        this.items = await getItems();
      } catch (err) {
        console.log(err);
        if (err.status == 401) {
          logout(this.$router);
        }
      }
      finally {
      // Hide loading image once data is fetched
      this.loading = false;
    }
    },
  },
};
</script>
